const MultipleReBaselineColumns = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: '80px'
  },
  {
    title: 'Webpage Name',
    dataIndex: 'name',
    slot: 'webpageName'
  },
  {
    title: 'Webpage URL',
    dataIndex: 'url',
    slot: 'webpageUrl'
  },
  {
    title: 'Health Status',
    dataIndex: 'health_status',
    slot: 'healthStatus'
  },
  {
    title: 'Plan Type',
    dataIndex: 'plan_type',
    slot: 'planType'
  },
  {
    title: 'Last Verified',
    dataIndex: 'last_verify',
    slot: 'lastVerify'
  },
  {
    title: 'Polling Interval (mins)',
    dataIndex: 'polling_interval',
    slot: 'pollingInterval'
  }
];

export { MultipleReBaselineColumns };
